interface IconProps {
  color?: string
}

export const Mismatch = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="26px"
      height="27px"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1333 2.46673C6.9845 2.46673 1.99994 7.4513 1.99994 13.6001C1.99994 19.7488 6.9845 24.7334 13.1333 24.7334C19.282 24.7334 24.2666 19.7488 24.2666 13.6001C24.2666 7.4513 19.282 2.46673 13.1333 2.46673ZM0.266602 13.6001C0.266602 6.494 6.0272 0.733398 13.1333 0.733398C20.2393 0.733398 25.9999 6.494 25.9999 13.6001C25.9999 20.7061 20.2393 26.4667 13.1333 26.4667C6.0272 26.4667 0.266602 20.7061 0.266602 13.6001ZM18.4601 8.27313C18.7986 8.61158 18.7986 9.16033 18.4601 9.49878L14.3589 13.6L18.4601 17.7012C18.7985 18.0397 18.7985 18.5884 18.4601 18.9269C18.1216 19.2653 17.5729 19.2653 17.2344 18.9269L13.1332 14.8257L9.03203 18.9269C8.69358 19.2653 8.14484 19.2653 7.80638 18.9269C7.46793 18.5884 7.46793 18.0397 7.80638 17.7012L11.9076 13.6L7.80633 9.49878C7.46788 9.16033 7.46788 8.61158 7.80633 8.27313C8.14479 7.93467 8.69353 7.93467 9.03198 8.27313L13.1332 12.3744L17.2345 8.27313C17.5729 7.93467 18.1217 7.93467 18.4601 8.27313Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
